import Promise from 'promise-polyfill'
import getUrlParameter from './get-url-parameter'
import isDefined from './is-defined'
import logger from './logger'
import { pub } from './pub-sub'

/**
 * Asynchronously loads the eightlytics script, creating a local interim queue, that is sent once the script has loaded.
 *
 * @param {Window} window A reference to the main frame's window object.
 */
export function addToCart({ sku, quantity, successFn, errorFn, product }) {
  if (!isDefined(sku)) {
    const error = new Error(`sku is missing`)
    error.extra = arguments

    pub('sdk:addToCart:error', { error })

    return errorFn(error)
  }

  if (process.env.NODE_ENV !== 'production') {
    logger('sdk:addToCart', { sku, quantity, successFn, errorFn, product })
    pub('sdk:addToCart:success')
    return successFn()
  }

  if (!window._eightselect_shop_plugin || typeof window._eightselect_shop_plugin.addToCart !== 'function') {
    if (getUrlParameter('8S-cart-test') === 'error') {
      const errorMessage = `🛒 ERROR TEST - add ${sku} - please implement https://docs.8select.io/integration/warenkorb`
      alert(errorMessage)
      const error = new Error(errorMessage)
      pub('sdk:addToCart:error', { error })

      return errorFn(error)
    } else {
      alert(`🛒 SUCCESS TEST - add ${sku} - please implement https://docs.8select.io/integration/warenkorb`)
      pub('sdk:addToCart:success')

      return successFn()
    }
  }

  return window._eightselect_shop_plugin
    .addToCart(sku, quantity, Promise, product)
    .then(result => {
      pub('sdk:addToCart:success')
      return successFn(result)
    })
    .catch(error => {
      pub('sdk:addToCart:error', { error })
      return errorFn(error)
    })
}

export default addToCart
